export default __webpack_public_path__ + "beaabea349fcc58ffae953f94b9db627.png";